import styled from 'styled-components';

const LoadingSpinnerBackground = styled.div`
  z-index: 1001;
  position: fixed;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur($blur);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
`;

const Spinner = styled.div`
  animation: spin 1s infinite linear;
  border: 0.25rem solid #a3b0a0;
  border-left: 0.25rem solid #1c3a13;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  position: fixed;
  top: 50%;
  z-index: 10002;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingSpinner = () => (
  <LoadingSpinnerBackground>
    <Spinner />
  </LoadingSpinnerBackground>
);

export default LoadingSpinner;
